import { render, staticRenderFns } from "./pingan.vue?vue&type=template&id=1622a66b&scoped=true&"
import script from "./pingan.vue?vue&type=script&lang=js&"
export * from "./pingan.vue?vue&type=script&lang=js&"
import style0 from "./pingan.vue?vue&type=style&index=0&id=1622a66b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1622a66b",
  null
  
)

export default component.exports